import { render, staticRenderFns } from "./guessingGamePraizesSetting.vue?vue&type=template&id=36ae2916&scoped=true"
import script from "./guessingGamePraizesSetting.vue?vue&type=script&lang=ts"
export * from "./guessingGamePraizesSetting.vue?vue&type=script&lang=ts"
import style0 from "./guessingGamePraizesSetting.vue?vue&type=style&index=0&id=36ae2916&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ae2916",
  null
  
)

export default component.exports